import * as trace from 'owa-trace';
import { initializeLightningIfNecessary } from 'owa-lightning-core-v2/lib/utils/initializeLightningIfNecessary';
import { isLightningIdPresent, resolveLightningPromises } from './isLightningIdPresent';
import { updateItemOnServer } from 'owa-lightning-core-v2/lib/services/updateItemOnServer';

const ACTION_TYPE_FOR_SESSION_TRACK = 'Secondary';

/**
 * Function to trigger unseen lightning api call.
 */
export async function initializeCampaignFramework() {
    try {
        await initializeLightningIfNecessary();
        resolveLightningPromises();
    } catch {
        trace.errorThatWillCauseAlert('Error in initializing the campaign framework.');
    }
}

/**
 * Function to update the campaign session count.
 * @param idToTrackSession Lightning id to be used for tracking the campaign session.
 */
export function updateCampaignSessionCount(idToTrackSession: string) {
    try {
        isLightningIdPresent(idToTrackSession) &&
            updateItemOnServer(idToTrackSession, ACTION_TYPE_FOR_SESSION_TRACK);
    } catch {
        trace.errorThatWillCauseAlert('Error in updating the campaign session.');
    }
}
